import { Fragment, useMemo, useCallback } from 'react';
import { useSwipeable } from 'react-swipeable';
import Date from './Date';
import { CALC_DIR, setWeekDateArr, setCalcWeekDateObj } from '@features/calendar/core';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { setDrawDate, selectedDrawDate } from '@features/calendar/CalendarSlice';
import type { IDateObj, IDataByDateMap } from '@type/index';

interface IWeekProps {
  dataByDateMap: IDataByDateMap;
  isShowCalendarMark: boolean;
}

const Week = ({ dataByDateMap, isShowCalendarMark }: IWeekProps) => {
  const dispatch = useAppDispatch();
  const drawDate = useAppSelector(selectedDrawDate);
  const weekDateArr = useMemo(() => setWeekDateArr(drawDate), [drawDate]);

  const swipeCallback = useCallback((date: IDateObj) => {
    dispatch(setDrawDate(date));
  }, []);

  const goPrevWeek = useCallback(() => {
    const prevDate = setCalcWeekDateObj(drawDate, CALC_DIR.MINUS);
    swipeCallback(prevDate);
  }, [drawDate]);

  const goNextWeek = useCallback(() => {
    const nextDate = setCalcWeekDateObj(drawDate, CALC_DIR.PLUS);
    swipeCallback(nextDate);
  }, [drawDate]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: goNextWeek,
    onSwipedRight: goPrevWeek,
  });

  return (
    <div className="week calendar-week" {...swipeHandlers}>
      {Array.isArray(weekDateArr) && weekDateArr?.length > 0 ? (
        weekDateArr?.map((date, i) => {
          const { year, month } = drawDate || {};
          const hasData =
            !!date &&
            dataByDateMap &&
            Array.isArray(dataByDateMap[year]) &&
            dataByDateMap[year][month - 1][date - 1]?.length > 0;
          const hasMark = isShowCalendarMark && hasData;

          return <Date key={`${date}-${i}`} dateObj={{ ...drawDate, date, day: i }} hasMark={hasMark} />;
        })
      ) : (
        <Fragment />
      )}
    </div>
  );
};

export default Week;
